
import React from "react";

export function Footer() {
  return (
    <footer className="bg-white border-t py-6">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center space-x-2 mb-4">
            <span className="text-shekel-600 text-2xl font-bold">₪</span>
            <span className="font-bold text-lg text-shekel-800">Shekel</span>
          </div>
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} Shekel. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
